import { render, staticRenderFns } from "./ArchiveUnavailablePopup.vue?vue&type=template&id=3566cc98&scoped=true&lang=pug"
import script from "./ArchiveUnavailablePopup.vue?vue&type=script&lang=ts"
export * from "./ArchiveUnavailablePopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3566cc98",
  null
  
)

/* custom blocks */
import block0 from "./ArchiveUnavailablePopup.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FPopups%2FArchiveUnavailablePopup.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports